import React, { memo } from 'react';

import { DatasetLayoutViewModelType } from '../../../services/category/view-model/DatasetLayoutViewModel';

import { CategoryLayoutElementContainerProps } from './CategoryLayoutElementContainer';
import CategoryDatasetContainer from './layout-elements/CategoryDataset/CategoryDatasetContainer';
import CategorySplitPanel from './layout-elements/CategorySplitPanel';
import CategoryTabsContainer from './layout-elements/CategoryTabsContainer';

const CategoryLayoutElement: React.FC<CategoryLayoutElementContainerProps> = ({
  categoryId,
  element,
  showCommands,
  onResize,
}) => {
  switch (element?.type) {
    case DatasetLayoutViewModelType.HORIZONTALLY_STACKED:
    case DatasetLayoutViewModelType.VERTICALLY_STACKED:
      return (
        <CategorySplitPanel
          categoryId={categoryId}
          element={element}
          showCommands={showCommands}
          horizontal={
            element.type === DatasetLayoutViewModelType.HORIZONTALLY_STACKED
          }
          onResize={onResize}
        />
      );

    case DatasetLayoutViewModelType.TABBED:
      return (
        <CategoryTabsContainer
          categoryId={categoryId}
          element={element}
          showCommands={showCommands}
        />
      );

    case DatasetLayoutViewModelType.SINGLE:
      return (
        <CategoryDatasetContainer
          datasetId={element.dataset}
          showCommands={showCommands}
          tabIndex={element.tabIndex}
        />
      );

    default:
      return null;
  }
};

export default memo(CategoryLayoutElement);
